import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Form, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { Search, Filter, Export, RewardSum, RewardSumList, agentReward, agentRewardreport } from '../../Constant';
import { viewAgentReward, viewAgentRewardRole, viewRewardReport, viewRewardReportRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import { agentRewardColumns, RewardSummaryColumns } from '../../Data/MockTable/ReportTableHeader';
import Progress from '../Common/Progress';
import { Controller, useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import UserDropdown from '../Common Field/UserDropdown';

const AgentReward = () => {
    const { register, handleSubmit, setValue } = useForm({});
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const sortedBy = params.get("sortBy") || '';
    const sortedOrder = params.get("sortOrder") || '';
    const searchKey = params.get('search') || '';
    const start_date =  params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : ''
    const end_date = params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : ''
    const agent = params.get('agent') || '';
    const authState = useSelector((state) => state.auth);
    const [customerLists, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const [filters, setFilters] = useState({
        searchKey: searchKey,
        start_date: start_date,
        end_date: end_date,
        agent: agent
    });
    const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
    const [startDate, endDate] = dateRange
    const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
    const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';

    useEffect(() => {
        fetchPackageSum(1);
        if (searchKey) {
            setValue('search', searchKey)
        }
        if (agent) {
            setValue('user', agent)
        }
    }, []);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/agent-reward?search=${filters.searchKey}&start_date=${filters.start_date}&end_date=${filters.end_date}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/agent-reward?search=${filters.searchKey}&start_date=${filters.start_date}&end_date=${filters.end_date}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handlePageChange = page => {
        fetchPackageSum(page, perPage, filters.searchKey, filters.start_date, filters.end_date, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchPackageSum(page, newPerPage, filters.searchKey, filters.start_date, filters.end_date, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };
    const onSubmit = async (data) => {

        let search = data?.search;
        const agent = data?.user || ''
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        const queryParams = new URLSearchParams({
            search: search,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
            agent: agent,
            end_date: end_date,
            start_date: start_date
        }).toString();
        navigate(`/report/agent-reward?${queryParams}`);
        setFilters({
            search,
            agent,
            start_date,
            end_date
        });
        fetchPackageSum(currentPage, perPage, search, agent);
    };


    const fetchPackageSum = async (page, size = perPage) => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewAgentReward + `?page=${page}&page_length=${size}&search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}&agent_id=${filters?.agent}` :
            viewAgentRewardRole +`?page=${page}&page_length=${size}&search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}&agent_id=${filters?.agent}`);
        if (response.status === true) {

            const valuePackages = response.data.data
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(Object.keys(valuePackages).map((e, index) => {
                return {
                    Si: SerialNo + index,
                    agent_name: valuePackages[e].agent_name,
                    email: valuePackages[e].email,
                    mobile: valuePackages[e].mobile,
                    reward_points: valuePackages[e].reward_points,
                    id: valuePackages[e].agent_id
                }
            }
            ))
            setTotalRows(response.data.total);
            setLoading(false);
        } else {
            handleApiError(response.status)
        }
    };

    const exportRewardSummaryExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAgentReward +
            `?export=reward_summary_report&search=${filters?.searchKey ? filters.searchKey : ''}&start_date=${filters?.start ?? ''}&end_date=${filters?.end ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}&agent_id=${filters?.agent}` :
            viewAgentRewardRole + `?export=reward_summary_report&search=${filters?.searchKey ? filters.searchKey : ''}&start_date=${filters?.start ?? ''}&end_date=${filters?.end ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}&agent_id=${filters?.agent}`);
        const dataToExport = response.data.map(({ agent_name, email, mobile, reward_points }) =>
            ({ Agent_Name: agent_name, Email: email, Phone: mobile, Reward_Points: reward_points, }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Reward Summary Data');
            XLSX.writeFile(wb, 'agent_reward_data.xlsx');
        } else {
            handleApiError(response.status)
        }
        setLoading(false);
    };

    const exportRewardSummaryPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAgentReward +
            `?export=reward_summary_report&search=${filters?.searchKey ? filters.searchKey : ''}&start_date=${filters?.start ?? ''}&end_date=${filters?.end ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}&agent_id=${filters?.agent}` :
            viewAgentRewardRole + `?export=reward_summary_report&search=${filters?.searchKey ? filters.searchKey : ''}&start_date=${filters?.start ?? ''}&end_date=${filters?.end ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}&agent_id=${filters?.agent}`);
        const dataToExport = response.data.map(({ agent_name, email, mobile, reward_points }, index) => ({ Sl: index + 1, agent_name, email, mobile, reward_points }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Agent Name", "Email", "Mobile", "Reward Ponits"];
            const rows = dataToExport.map(({ agent_name, email, mobile, reward_points }, index) => [index + 1, agent_name, email, mobile, reward_points]);
            doc.autoTable({
                head: [columns],
                body: rows
            });
            doc.save("agent_reward_data.pdf");
        } else {
            handleApiError(response.status)
        }
        setLoading(false);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={agentReward} parent="Reports" title={agentReward} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{agentRewardreport}</H3>
                    <div >
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportRewardSummaryExcel()} ><i className="fa fa-file-excel-o me-2"></i>Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportRewardSummaryPdf()}><i className="fa fa-file-pdf-o me-2"></i>Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>

                        <Col sm="12" md="5" lg='2' className="form-element">
                            <UserDropdown
                                label={"Agent"}
                                authState={authState}
                                registerName="user"
                                selectedUserId={filters.agent}
                                register={register}
                                setValue={setValue}
                            />
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element" >
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <DatePicker
                                    className="form-control digits w-100"
                                    selectsRange
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    isClearable
                                    monthsShown={2}
                                    popperPlacement="bottom"
                                    calendarClassName='parallel-calendar'
                                    placeholderText='Select Date Range'
                                />
                            </div>
                        </Col>
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={agentRewardColumns(authState)}
                            data={customerLists}
                            // onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default AgentReward;